import { ISaveService } from "../../../../../abstractions/services/actions/ISaveService";
import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { VentaAnimalesRequest } from "../../../../../modulos/pesaje/ganaderia/request/VentaAnimalesRequest";
import { VentaAnimalesResponse } from "../../../../../modulos/pesaje/ganaderia/response/VentaAnimalesResponse";
import { VentaAnimalesSaveGrpcService } from "../../../../../modulos/pesaje/ganaderia/services/VentaAnimalesSaveGrpcService";
import { BaseFullScreenFormModalRender } from "../../../../base/modal/BaseFullScreenFormModalRender";
import { IFormBodyRender } from "../../../../definitions/form/IFormBodyRender";
import { VentaFormRender } from "../form/VentaFormRender";

/** Modal a pantalla completa de creación/edición de una venta de animales.
 *  Hospeda el `VentaFormRender` y guarda con `VentaAnimalesSaveGrpcService`. */
export class VentaModalRender extends BaseFullScreenFormModalRender<
  VentaAnimalesRequest,
  VentaAnimalesResponse
> {
  protected readonly elementId = "ventaModal";

  protected get title(): string {
    return "Venta de animales";
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().get()?.nombreFinca;
  }

  protected get saveLabel(): string {
    return "Registrar Venta";
  }

  protected getFormBody(): IFormBodyRender {
    return new VentaFormRender(this._request);
  }

  protected get saveService(): ISaveService<
    VentaAnimalesRequest,
    VentaAnimalesResponse
  > {
    return new VentaAnimalesSaveGrpcService();
  }
}
